"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeTooltipArrow = exports.Width = exports.Height = void 0;
var React = require("react");
var TabStyles_1 = require("../../styles/TabStyles");
var ChromeTooltipUtility_1 = require("./ChromeTooltipUtility");
exports.Height = 12;
exports.Width = 6;
var Stroke = TabStyles_1.TabStyles.Colors.L5;
var Fill = TabStyles_1.TabStyles.Colors.White;
var StrokeWidth = TabStyles_1.TabStyles.Sizing.BorderWidth;
function ChromeTooltipArrow(_a) {
    var direction = _a.direction, style = _a.style;
    var points = getPoints(direction).map(function (_a) {
        var x = _a.x, y = _a.y;
        return x + ',' + y;
    }).join(' ');
    return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', style: style, height: getHeight(direction), width: getWidth(direction) },
        React.createElement("polyline", { points: points, fill: Fill, stroke: Stroke, strokeWidth: StrokeWidth })));
}
exports.ChromeTooltipArrow = ChromeTooltipArrow;
function getHeight(direction) {
    return direction === 'Left' || direction === 'Right' ? exports.Height : exports.Width;
}
function getWidth(direction) {
    return direction === 'Left' || direction === 'Right' ? exports.Width : exports.Height;
}
function getPoints(direction) {
    switch (direction) {
        case 'Up': return [{ x: 0, y: exports.Width }, { x: exports.Height / 2, y: 0 }, { x: exports.Height, y: exports.Width }];
        case 'Down': return [{ x: 0, y: 0 }, { x: exports.Height / 2, y: exports.Width }, { x: exports.Height, y: 0 }];
        case 'Left': return [{ x: exports.Width, y: 0 }, { x: 0, y: exports.Height / 2 }, { x: exports.Width, y: exports.Height }];
        case 'Right': return [{ x: 0, y: 0 }, { x: exports.Width, y: exports.Height / 2 }, { x: 0, y: exports.Height }];
        default: return ChromeTooltipUtility_1.assertNever(direction);
    }
}
//# sourceMappingURL=ChromeTooltipArrow.js.map